import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@app/modules';
import { AppState } from '@app/reducers';
import {ComponentProperties, CrudType,exportList,
  CustomDirectiveConfig, debounceTimeForSearchkeyword, LoggedInUserModel,
  ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams, ResponseMessageTypes, RxjsService, SnackbarService,currentComponentPageBasedPermissionsSelector$, prepareDynamicTableTabsFromPermissions, IApplicationResponse
} from '@app/shared';
import { map} from 'rxjs/operators';
import { PrimengStatusConfirmDialogComponent } from '@app/shared/components/primeng-status-confirm-dialog/primeng-status-confirm-dialog.component';
import { CrudService } from '@app/shared/services';
import { TableFilterFormService } from '@app/shared/services/create-form.services';
import { MomentService } from '@app/shared/services/moment.service';
import { loggedInUserData } from '@modules/others';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-plant-list',
  templateUrl: './plant-list.component.html',
 styleUrls: ['./plant-list.component.scss']
})
export class PlantListComponent extends PrimeNgTableVariablesModel {
  otherParams;
  observableResponse;
  componentProperties = new ComponentProperties();
  primengTableConfigProperties: any;
 // status: any = [];
  selectedColumns: any[];
  selectedRows: string[] = [];
  searchKeyword: FormControl;
  searchForm: FormGroup;
  columnFilterForm: FormGroup;
  today: any = new Date()
  pageSize: number = 10;
  searchColumns: any
  row: any = {}
  dateFormat = 'yyyy-MM-dd';
  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });
  first=0;
  status = [
    { label: 'Active', value: true },
    { label: 'In-Active', value: false },
  ]
  constructor(private crudService: CrudService, private tableFilterFormService: TableFilterFormService,
    private activatedRoute: ActivatedRoute,private snackbarService:SnackbarService,
    public dialogService: DialogService, private router: Router,
    private store: Store<AppState>, private momentService: MomentService,
    private rxjsService: RxjsService, private _fb: FormBuilder, private datePipe :DatePipe) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Warehouse Management",
      selectedTabIndex: 0,
      breadCrumbItems: [{displayName:'Inventory management', relativeRouterUrl: ''},{ displayName: 'Stock & Warehouse Management ', relativeRouterUrl: '' }, { displayName: 'Warehouse Management' },{ displayName: 'Warehouse', relativeRouterUrl: '' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Warehouse',
            dataKey: 'warehouseId',
            enableAction: true,
            enableBreadCrumb: true,
            enableExportBtn: true,
            enablePrintBtn: true,
            printTitle: 'Warehouse',
            printSection: 'print-section0',
            enableScrollable: true,
            enableFieldsSearch: true,
            rowExpantableIndex: 0,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'warehouseCode', header: 'Warehouse Code', width: '200px' },
              { field: 'status', header: 'Status', width: '200px',type: 'dropdown', options: this.status },
              { field: 'warehouseName', header: 'Warehouse Name', width: '200px' },
              { field: 'contactName', header: 'Contact Name', width: '200px' },
              { field: 'officeNumber', header: 'Contact Number', width: '200px' },
              { field: 'contactAddress', header: 'Contact Address', width: '200px' },
              ],
            apiSuffixModel: InventoryModuleApiSuffixModels.PLANT,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
            disabled:true
          },
          {
            caption: 'Storage Location',
            dataKey: 'storageLocationId',
            enableBreadCrumb: true,
            enableAction: true,
            enableExportBtn: true,
            enablePrintBtn: true,
            printTitle: 'Storage Location',
            printSection: 'print-section1',
            enableScrollable: true,
            enableFieldsSearch: true,
            rowExpantableIndex: 0,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'storageLocationName', header: 'Storage Location', width: '200px' },
              { field: 'isActive', header: 'Status', width: '200px' },
              { field: 'storageType', header: 'Storage Type', width: '200px' },
              { field: 'createdDate', header: 'Created Date & Time', width: '200px',isDateTime:true },
              { field: 'modifiedDate', header: 'Modified Date & Time', width: '200px',isDateTime:true }
              ],
            apiSuffixModel: InventoryModuleApiSuffixModels.STORAGE_LOCATION,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
            shouldShowCreateActionBtn: true,
            disabled:true
          }
        ]
      }
    }

    this.searchForm = this._fb.group({ searchKeyword: "" });
    this.columnFilterForm = this._fb.group({});
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      //this.primengTableConfigProperties.breadCrumbItems[3].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
    this.status = [
      { label: 'Active', value: true },
      { label: 'Inactive', value: false },
    ]

  }

  ngOnInit(): void {
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns);
    this.searchKeywordRequest();
    this.columnFilterRequest();
    this.combineLatestNgrxStoreData()
    this.getRequiredListData();
  }

  export(){
    let pageIndex =  this.row && this.row ["pageIndex"] ?  this.row ["pageIndex"]:0;
    let pageSize  =  this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
    this.exportList(pageIndex,pageSize);
  }

  exportList(pageIndex?: any, pageSize?: any) {
    let api;let label;
    if(this.selectedTabIndex==0){
      api = InventoryModuleApiSuffixModels.WAREHOUSES_EXPORT;
      label= 'Warehouse';
    }
    else if(this.selectedTabIndex==1){
      api = InventoryModuleApiSuffixModels.STORAGELOCATIONS_EXPORT;
      label= 'Storage Location';
    }


    exportList(this.otherParams,0,pageSize,ModulesBasedApiSuffix.INVENTORY,
      api,this.crudService,this.rxjsService,label);
  }


  combineLatestNgrxStoreData() {
    combineLatest([  this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][INVENTORY_COMPONENT.WAREHOUSE_MANAGEMENT];
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
     //   this.selectedTabIndex = +prepareDynamicTableTabsFromPermissionsObj['selectedTabIndex'];
      }
    });
  }

  searchKeywordRequest() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(val => {
          return of(this.onCRUDRequested(CrudType.GET, {}));
        })
      )
      .subscribe();
  }

  columnFilterRequest() {
    this.columnFilterForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(obj => {
          Object.keys(obj).forEach(key => {
            if (obj[key] === "") {
              delete obj[key]
            }
          });
          this.searchColumns = Object.entries(obj).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {}) //Filter all falsy values ( null, undefined )
          this.row['searchColumns'] = this.searchColumns
          return of(this.onCRUDRequested(CrudType.GET, this.row));
        })
      )
      .subscribe();
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    // if(this.selectedTabIndex == 0) {
      otherParams = {
        userId: this.loggedInUserData?.userId,
        ...otherParams,
      }
    // }
    this.otherParams = otherParams
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).pipe(map((res: IApplicationResponse) => {
      if (res?.resources) {
        res?.resources?.forEach(val => {
         // val.isActive =  val.status;
          return val;
        })
      }
      return res;
    }))
    .subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.observableResponse = data.resources;
        this.dataList = this.observableResponse;
        this.totalRecords = data.totalCount;
      } else {
        this.observableResponse = null;
        this.dataList = this.observableResponse
        this.totalRecords = 0;

      }
    })
  }

  loadPaginationLazy(event) {
    let row = {}
    row['pageIndex'] = event.first / event.rows;
    row["pageSize"] = event.rows;
    row["sortOrderColumn"] = event.sortField;
    row["sortOrder"] = event.sortOrder == 1 ? 'ASC' : 'DESC';
    this.first = event.first;
    // this.row = row;
    this.row = Object.assign(this.row, row);
    this.onCRUDRequested(CrudType.GET, this.row);
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?:any): void {

    switch (type) {
      case CrudType.CREATE:
         if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
            return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
         }
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        let otherParams = {};
        if (this.searchForm.value.searchKeyword) {
          otherParams["search"] = this.searchForm.value.searchKeyword;
        }
        if (Object.keys(this.row).length > 0) {
          // logic for split columns and its values to key value pair

          if (this.row['searchColumns']) {
            Object.keys(this.row['searchColumns']).forEach((key) => {
              if (key.toLowerCase().includes('date')) {
                otherParams[key] = this.momentService.localToUTCDateTime(this.row['searchColumns'][key]);
              } else {
                otherParams[key] = this.row['searchColumns'][key];
              }
            });
          }

        }
        //otherParams= {...otherParams,...unknownVar}

        // if(unknownVar?.isActive == true || unknownVar?.isActive == false ){
        //   unknownVar.status = unknownVar?.isActive;
        //   delete unknownVar.isActive;
        // }
        this.getRequiredListData(row["pageIndex"], row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EXPORT:
          if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canExport) {
            return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
          }
          this.export();
          break;

      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        switch (this.selectedTabIndex) {
          case 1:
            this.router.navigateByUrl("inventory/warehouse/bin-management/storage-location/add-edit");
            break;
        }
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(["inventory/warehouse/view"], { queryParams: { warehouseId: editableObject['warehouseId'] }, skipLocationChange: true });
            break;
          case 1:
            this.router.navigate(["inventory/warehouse/bin-management/storage-location/view"], { queryParams: { id: editableObject['storageLocationId'] }, skipLocationChange: true });
            break;
        }
    }
  }

  onTabChange(event) {
    this.row = {}
    this.columnFilterForm = this._fb.group({})
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[event.index].columns);
    this.columnFilterRequest();
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index
    this.router.navigate(['/inventory/warehouse'], { queryParams: { tab: this.selectedTabIndex } });
    this.pageSize=10;
    this.first=0;
    this.getRequiredListData();
  }

  onBreadCrumbClick(breadCrumbItem: object): void {
    if (breadCrumbItem.hasOwnProperty('queryParams')) {
      this.router.navigate([`${breadCrumbItem['relativeRouterUrl']}`],
        { queryParams: breadCrumbItem['queryParams'] })
    }
    // [breadCrumbItem['queryParams']['key']]: breadCrumbItem['queryParams']['value']
    else {
      this.router.navigateByUrl(`${breadCrumbItem['relativeRouterUrl']}`)
    }
  }
  onActionSubmited(e) {
    if (e.data && !e.search && !e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data);
    } else if (e.data && e.search && !e?.col) {
      this.onCRUDRequested(e.type, e.data, e.search);
    } else if (e.type && !e.data && !e?.col) {
      this.onCRUDRequested(e.type, {});
    } else if (e.type && e.data && e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data, e?.col);
    }
  }
  onChangeStatus(rowData, index) {
    const ref = this.dialogService.open(PrimengStatusConfirmDialogComponent, {
      // header: 'Choose a Car',
      showHeader: false,
      baseZIndex: 10000,
      width: '400px',
      data: {
        index: index,
        ids: rowData[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey],
        isActive: rowData.isActive,
        modifiedUserId: this.loggedInUserData.userId,
        moduleName: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
        apiSuffixModel: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel
      },
    });
    ref.onClose.subscribe((resp) => {
      if (!resp) {
        this.dataList[index].isActive = this.dataList[index].isActive ? false : true;
      }
    });
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet((this.selectedRows.length > 0) ? this.selectedRows : this.dataList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
}
